import { useEffect as i } from "react";
import { useAttribution as u } from "./attribution.js";
import { useLeafletContext as c } from "./context.js";
import { useEventHandlers as f } from "./events.js";
import { withPane as m } from "./pane.js";
function s(e, r) {
  i(function() {
    return (r.layerContainer ?? r.map).addLayer(e.instance), function() {
      var o;
      (o = r.layerContainer) == null || o.removeLayer(e.instance), r.map.removeLayer(e.instance);
    };
  }, [
    r,
    e
  ]);
}
function l(e) {
  return function(t) {
    const n = c(), a = e(m(t, n), n);
    return u(n.map, t.attribution), f(a.current, t.eventHandlers), s(a.current, n), a;
  };
}
export {
  l as createLayerHook,
  s as useLayerLifecycle
};
